import React, { useState, useEffect, useRef } from 'react';
import {
  Row,
  Col,
  Button,
  CardBody,
  Card,
  Label,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Dropdown } from 'reactstrap';
import { DebounceInput } from 'react-debounce-input';
import { useSelector, useDispatch, connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import RelatorioApi from '../relatorio.api';
import * as commonActions from '../../../app/common/common.action';
import * as actions from '../../../app/common/common.action';
import ModalComponent from '@componentes/modal/modal.component';
import MorfologiaContainer from '@common/morfologia/morfologia.container';
import Grid from './Grid';
import LaudoApi from '../../../pages/laudo/laudo.api';
import WebapiCommon from '../../../app/common/util/webapi.common';
import CommonFunctions from '@common/util/functions.common';
import ModalImprimirContainer from '../../main/listagem/modais/imprimir_laudo/modal.imprimir.container';
import IntlMessage from "../../../helpers/intlMessage";
import * as DefautUtil from '@common/util/defaultValues';
import { changePeriod, getDate, obterListagemDePeriodos } from '../../../helpers';
import { useIntl } from 'react-intl';
import SelectComponent from '@componentes/select/select.component';

const TOTAL_ITEMS_PAGE = 10;

const LaudoSemCid = ({ commonActions, modalImprimir, }) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const [filter, setFilter] = useState({});
  const loading = useSelector(state => state.commonReducer.showCarregando);
  const [list, setList] = useState([]);
  const [page, setPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [modalCID, setModalCID] = useState(false);
  const [modalSize, setModalSize] = useState('');
  const [modalTitle, setModalTitle] = useState('');
  const [, setCidPadrao] = useState(false);
  const [dropdownOpenOrdenacao, setDropdownOpenOrdenacao] = useState(false);
  const [ordenacaoSelecionada, setOrdenacaoSelecionada] = useState(DefautUtil.enumFiltroRelatorioLaudoSemCidListOrder(intl)[0]);
	const [periodo, setPeriodo] = useState({ value: 'hoje', label: `${intl.formatMessage({ id: "period.today" })}` });
	const periodos = obterListagemDePeriodos(intl);

  useEffect(() => {
    const periodo = CommonFunctions.getPeriodosSubDays(0);
    const { periodoInicial, periodoFinal } = periodo;

    setFilter({ periodoInicial, periodoFinal });
  }, []);

  const firstRender = useRef(true);
  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return
    }
    handleFilter();
  }, [page, ordenacaoSelecionada]);

  const handleFilter = async () => {
    const params = {
      dataIni: filter.periodoInicial,
      dataFim: filter.periodoFinal,
      ordenacao: ordenacaoSelecionada.value
    }

    const result = CommonFunctions.validaData(params.dataIni, params.dataFim, intl, commonActions);

    if (!result.valid) {
      dispatch(commonActions.showAlerta('alerta', result.message, 3000));
      return;
    }

    dispatch(commonActions.showFadeCarregando(true));
    const response = await RelatorioApi.getLaudosSemCid(page, TOTAL_ITEMS_PAGE, params)
    setList(response.data)
    setTotalItems(response.totalItems)
    dispatch(commonActions.showFadeCarregando(false));

    if (response.data.length === 0)
      dispatch(commonActions.showAlerta('alerta', <IntlMessage id="dashboards.reports.noResultsFound" />, 3000));
  }

  const getCountPreviousReports = prontuario => {
    WebapiCommon.getLaudosAnterioresQuantidade(prontuario).then(result => {
      dispatch(commonActions.preenhcerTotalLaudosAnteriores(result));
    });
  };

  const getReportDetails = item => {
    const { laudo, prontuario, etapas, exame, nenhumaEtapaAplicavel } = item;

    if (nenhumaEtapaAplicavel) {
      const msg = `O tipo de exame ${exame} não possui nenhuma etapa aplicável`;
      const tamanho = msg.length * 10 + 'px';
      dispatch(commonActions.showAlerta('alerta', msg, 3500, tamanho));
    } else {
      WebapiCommon.getDetalhes(laudo).then(response => {
        dispatch(
          commonActions.atualizarLaudoSelecionado({ laudo, prontuario, exame })
        );
        getCountPreviousReports(prontuario);
        dispatch(commonActions.atualizarDetalhes({ ...response, etapas }));
        WebapiCommon.getHistoricoNaoConformidades(response.laudo).then(result =>
          dispatch(commonActions.preenhcerHistoricoInconformidades(result))
        );
      });
    }
  };

  const handleModalCid = (item) => {
    dispatch(commonActions.showFadeCarregando(true));
    const { laudo } = item.data;

    LaudoApi.getLaudo(laudo).then(response => {
      if (response) {
        const { listagem } = response;
        if (listagem && listagem.length) {
          const [laudo] = listagem;

          setModalTitle(`CID do laudo ${laudo.laudo}`)
          getReportDetails(laudo);
          dispatch(commonActions.atualizarDetalhes(laudo))
        }
      }
    }).finally(() => {
      setModalCID(true);
      setModalSize('lg');
      dispatch(commonActions.showFadeCarregando(false));
    });
  }

  const closeModalCID = () => {
    setModalCID(false)
    handleFilter()
  }

  const handlePrintReport = (item) => {
    const { laudo } = item;

    LaudoApi.getLaudo(laudo).then(response => {
      if (response) {
        const { listagem } = response;
        if (listagem && listagem.length) {
          commonActions.mudarStatusModalImprimir(true, listagem[0]);
        }
      }
    })
  }

	function resetarPeriodo() {
		setPeriodo('');
    setFilter({ ...filter, periodoInicial: null, periodoFinal: null });
	}

	function periodoAlterado(e) {
		if (!e || !e.value) {
		  return resetarPeriodo();
		}

		let payload = getDate(e.value);
		payload.dtinicial = payload.dtinicial.toISOString().slice(0, 10);
		payload.dtfinal = payload.dtfinal.toISOString().slice(0, 10);

    setPeriodo(e);
    setFilter({ ...filter, periodoInicial: payload.dtinicial, periodoFinal: payload.dtfinal });
	}

	function mudarIntervaloPeriodo(val) {
		let payload = changePeriod(val);

    setFilter({ ...filter, periodoInicial: payload.start, periodoFinal: payload.end });
	}

  function eventoOnKeyPressData(event) {
		if (event.key === "Enter") {
      const result = CommonFunctions.validaData(filter.periodoInicial, filter.periodoFinal, intl);

      if (!result.valid) {
        dispatch(commonActions.showAlerta('alerta', result.message, 3000));
        return;
      }

			handleFilter(filter);
    }
	}

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <Row>
            <Col
              sm={'auto'}
            >
              <Row style={{ marginRight: '15px' }}>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'auto', width: 'auto' }}>
                  <div className="label-data"><IntlMessage id="period.name"/></div>
                  <div className="form-group has-float-label" style={{width: '200px', display: 'block'}}>
                  <SelectComponent
                    isClearable
                    className="filtro-data"
                    noOptionsMessage={() => {
                    return intl.formatMessage({id: "dashboards.reports.noItemsFound"});
                    }}
                    name="form-field-period"
                    placeholder={`${intl.formatMessage({id: "dashboards.general.selectPeriod"})}`}
                    value={periodo}
                    onChange={(e) => {
                    periodoAlterado(e);
                    e && e.value ? mudarIntervaloPeriodo(e.value) : mudarIntervaloPeriodo('todos');
                    }}
                    options={periodos}
                  />
                  </div>

                  {periodo && periodo.value === 'outro' && (
                  <React.Fragment>
                    <DebounceInput
                    name="periodoDe"
                    type="date"
                    style={{width: '130px', display: 'block'}}
                    className="filtro-data"
                    value={filter.periodoInicial}
                    onChange={e => setFilter({ ...filter, periodoInicial: e.target.value })}
                    onKeyPress={(e) => eventoOnKeyPressData(e)}
                    />
                    <DebounceInput
                    name="periodoAte"
                    type="date"
                    style={{width: '130px', display: 'block'}}
                    className="filtro-data"
                    value={filter.periodoFinal}
                    onChange={e => setFilter({ ...filter, periodoFinal: e.target.value })}
                    onKeyPress={(e) => eventoOnKeyPressData(e)}
                    />
                  </React.Fragment>
                  )}
                </div>
              </Row>
            </Col>
            <Col sm={1}>
              <Button
                className='btn btn-primary'
                onClick={() => handleFilter(filter)}
                style={{ height: '38px', width: '38px' }}
              >
                <i className='icons-btn mv-basico-pesquisar'></i>
              </Button>
            </Col>
            <Row className='laudo-sem_cid-ordem-filtro' style={{display: 'flex', justifyContent: 'flex-end'}}>
              <Col sm='auto'>
                <Label style={{marginRight: '10px', width: '100px'}}><IntlMessage id="dashboards.general.orderBy" /></Label>
                <Dropdown
                  style={{ display: 'inline' }}
                  isOpen={dropdownOpenOrdenacao}
                  toggle={() => setDropdownOpenOrdenacao(!dropdownOpenOrdenacao)}
                >
                  <DropdownToggle
                    color='#fff'
                    className='button'
                    caret
                    style={{ borderColor: 'transparent' }}
                  >
                    {ordenacaoSelecionada.label}
                  </DropdownToggle>
                  <DropdownMenu right>
                    {DefautUtil.enumFiltroRelatorioLaudoSemCidListOrder(intl).map((ordem, i) => (
                      <DropdownItem
                        key={i}
                        onClick={() => setOrdenacaoSelecionada(ordem)}
                      >
                        {ordem.label}
                      </DropdownItem>
                    ))}
                  </DropdownMenu>
                </Dropdown>
              </Col>
            </Row>
          </Row>
        </CardBody>
      </Card>

      {!!list.length && (
        <Grid
          lista={list}
          totalItens={totalItems}
          pagina={page}
          totalItensPage={TOTAL_ITEMS_PAGE}
          setPagina={setPage}
          onClickLine={handleModalCid}
          onClickImprimirLaudo={handlePrintReport}
        />
      )}

      {!list.length && (
        <div className='icone-semdados'>
          <i className='inicial-icons mv-basico-documento_eletronico'></i>
        </div>
      )}

      <ModalComponent
        size={modalSize}
        visivel={modalCID}
        cancela={closeModalCID}
        titulo={modalTitle}
      >
        <MorfologiaContainer
          cidPadrao={(val) => setCidPadrao({ cidPadrao: val })}
          altura={window.innerHeight - 215}
        />
      </ModalComponent>

      {modalImprimir && (
        <ModalImprimirContainer />
      )}
    </React.Fragment>
  );
}

const mapStateToProps = (state) => {
  return {
    detalhes: state.commonReducer.detalhes,
    modalImprimir: state.commonReducer.modalImprimir,
  };
};

const mapDispacthToProps = (dispatch) => {
  return {
    actions: bindActionCreators(actions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispacthToProps
)(LaudoSemCid);



// WEBPACK FOOTER //
// ./src/pages/relatorio/LaudoSemCid/index.js